module.exports = __webpack_public_path__ + "img/BE0403212172.b776ba3a.png";